module.exports = __webpack_public_path__ + "img/business_capabilities.5161bd27.gif";